/* eslint-disable import/no-anonymous-default-export */
import axiosClient from "../lib/api/axiosClient";
// const endpoint = process.env.REACT_APP_API_ENDPOINT_ONE;
const endpoint_two = process.env.REACT_APP_API_ENDPOINT_TWO;
const api_version = process.env.REACT_APP_API_VERSION;

export const fetchAllStaff = async ({
  token,
  departmentId,
  status,
  searchText,
  pageSize = 10,
  pageNumber = 1,
}) => {
  const params = {
    PageSize: pageSize,
    PageNumber: pageNumber,
  };

  if (departmentId) params.DepartmentId = departmentId;
  if (status) params.Status = status;
  if (searchText) params.SearchText = searchText;

  return axiosClient
    .get(`${endpoint_two}/api/v${api_version}/HumanResources/staffs`, {
      params,
      headers: {
        authToken: token,
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)
    .catch((err) => err.response);
};

export const fetchAllLeavesRequest = async ({
  token,
  schoolId,
  status,
  searchText,
  pageSize = 10,
  pageNumber = 1,
}) => {
  const params = {
    PageSize: pageSize,
    PageNumber: pageNumber,
  };

  if (status) params.Status = status;
  if (searchText) params.SearchText = searchText;

  return axiosClient
    .get(
      `${endpoint_two}/api/v${api_version}/HumanResources/staff-requests/${schoolId}`,
      {
        params,
        headers: {
          authToken: token,
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);
};

export const UpdateLeaveRequest = async (token, payload) => {
  return axiosClient
    .put(
      `${endpoint_two}/api/v${api_version}/HumanResources/change-staff-request-status`,
      payload,
      {
        headers: {
          authToken: token,
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => err.response);
};
